
import { defineComponent } from "vue";
import LeftSideBarVue from "../components/LeftSideBar.vue";
import { topBarState } from "@/services/topBar";
import MobileSideBar from "@/components/MobileSideBar.vue";
import { userState } from "@/services/auth";
import { apiUrl, axiosAuthPost, errorHandling } from "@/services/utils";
import { BuildingService } from "@/services/BuildingService";

export default defineComponent({
    components: { LeftSideBarVue, MobileSideBar },
    mounted() {
        this.getBuildingName();
    },
    data() {
        return {
            title: topBarState.state,
            showMenu: false,
            authState: userState.state,
            outing: false,
            buildingName:'loading...',
            buildingService:new BuildingService()
        }
    },
    // listen for route change event
    watch: {
        $route(to, from) {
            this.getBuildingName();
        }
    },
    methods: {
        logout() {
            let logoutUrl = apiUrl + 'auth/logout';
            this.outing = true;
            axiosAuthPost(logoutUrl, {}).then((result) => {
                userState.clearAuth();
                this.$router.push('/login');
                this.outing = false;
            }).catch((err) => {
                errorHandling(err);
                this.outing = false;
            });
        },
        async getBuildingName() {
            this.buildingName = await this.buildingService.getBuildingName();
        },
        settings() {
            this.$router.push({ name: 'Settings', params: { building: this.$route.params.building } })
        }
    }
})
